exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._C6x{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_C6x",
	"root": "_C6x"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/BlogueAccueil/BlogueAccueil.css
// module id = 198
// module chunks = 0